import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
export function SettingsPage() {
  const handleSave = () => {
    toast.success('Nastavitve so bile shranjene');
  };
  return <div className="max-w-3xl mx-auto space-y-6" data-id="element-361">
      <PageHeader title="Nastavitve" description="Upravljanje sistemskih nastavitev in preferenc." data-id="element-362" />

      <Card data-id="element-363">
        <CardHeader data-id="element-364">
          <CardTitle data-id="element-365">Splošne nastavitve</CardTitle>
          <CardDescription data-id="element-366">Osnovne nastavitve aplikacije.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6" data-id="element-367">
          <div className="flex items-center justify-between" data-id="element-368">
            <div className="space-y-0.5" data-id="element-369">
              <Label className="text-base" data-id="element-370">Obvestila po e-pošti</Label>
              <p className="text-sm text-slate-500" data-id="element-371">
                Prejemanje obvestil o novih nalogih.
              </p>
            </div>
            <Switch defaultChecked data-id="element-372" />
          </div>

          <div className="flex items-center justify-between" data-id="element-373">
            <div className="space-y-0.5" data-id="element-374">
              <Label className="text-base" data-id="element-375">Samodejno shranjevanje</Label>
              <p className="text-sm text-slate-500" data-id="element-376">
                Shrani osnutek med urejanjem.
              </p>
            </div>
            <Switch defaultChecked data-id="element-377" />
          </div>

          <div className="flex items-center justify-between" data-id="element-378">
            <div className="space-y-0.5" data-id="element-379">
              <Label className="text-base" data-id="element-380">Kompaktni pogled tabel</Label>
              <p className="text-sm text-slate-500" data-id="element-381">
                Prikaži več vrstic na zaslonu.
              </p>
            </div>
            <Switch data-id="element-382" />
          </div>

          <div className="pt-4" data-id="element-383">
            <Button onClick={handleSave} data-id="element-384">Shrani nastavitve</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}